// src/App.tsx
import { Title } from '@gjensidige/builders-components';
import React from 'react';
import { CarForm } from './forms/CarForm';
import CarWinterImg from './images/car_travel_winter.webp';
import CarWinterImgSmall from './images/car_travel_winter_small.webp';

export const App: React.FC = () => {

  return (
    <header className="calculation-header">
      <div className="wrapper">
        <div className="background-img-wrapper">
          <picture>
            <source
              media="(min-width: 50em)"
              srcSet={CarWinterImg}
            />
            <img
              src={CarWinterImgSmall}
              alt="Background illustration"
              // @ts-ignore due to react-bug
              fetchpriority="high"
              loading="eager"
            />
          </picture>
        </div>
        <div className="content">
          <Title as='h1' uppercase={true} size="3">
            Se pris och köp din bilförsäkring
          </Title>
          <CarForm />
        </div>
      </div>
    </header>
  );
};